import { manifests as uiPickerModalManifests } from './ui-picker-modal/manifests.js';

export const manifests: Array<UmbExtensionManifest> = [...uiPickerModalManifests];
